(function() {
  'use strict';
  
  console.log('Video Grid Handler v2.1 - Force Override');
  
  // 既存のすべてのイベントリスナーを強制削除
  function removeAllEventListeners(element) {
    var clone = element.cloneNode(true);
    element.parentNode.replaceChild(clone, element);
    return clone;
  }
  
  window.initVideoGrid = function() {
    // 少し遅延させて他のスクリプトの後に実行
    setTimeout(function() {
      console.log('Initializing Video Grid...');
      
      var gridItems = document.querySelectorAll('.video-grid-item[data-block-id]');
      console.log('Found grid items:', gridItems.length);
      
      if (gridItems.length === 0) {
        console.error('No grid items found!');
        return;
      }
      
      gridItems.forEach(function(item, index) {
        // 完全にクリーンな要素を作成
        var cleanItem = removeAllEventListeners(item);
        
        // 新しいイベントリスナーを追加(キャプチャフェーズで優先実行)
        cleanItem.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); // 他のリスナーを完全にブロック
          
          var videoUrl = this.getAttribute('data-video-url');
          var productsJson = this.getAttribute('data-products');
          var blockId = this.getAttribute('data-block-id');
          
          console.log('=== Click Event v2.1 ===');
          console.log('Index:', index);
          console.log('Block ID:', blockId);
          console.log('Video URL:', videoUrl);
          
          if (!videoUrl || videoUrl === '') {
            alert('動画が設定されていません (Block: ' + blockId + ')');
            return false;
          }
          
          var products = [];
          try {
            products = productsJson ? JSON.parse(productsJson) : [];
          } catch(err) {
            console.error('商品データの解析エラー:', err);
          }
          
          var productsHtml = '';
          if (products.length > 0) {
            productsHtml = '<h3 class="products-title-v2">動画内で紹介した商品</h3><div class="products-grid-v2">';
            products.forEach(function(product) {
              productsHtml += '<a href="' + product.url + '" class="product-card-v2">';
              productsHtml += '<img src="' + product.image + '" alt="' + product.title + '">';
              productsHtml += '<div class="product-info-v2">';
              productsHtml += '<div class="product-title-v2">' + product.title + '</div>';
              productsHtml += '<div class="product-price-v2">' + product.price + '</div>';
              productsHtml += '</div></a>';
            });
            productsHtml += '</div>';
          }
          
          var popup = document.createElement('div');
          popup.className = 'modal-overlay-v2 active';
          popup.innerHTML = '<div class="modal-container-v2"><button class="modal-close-v2">✕</button><div class="modal-video-v2"><video controls autoplay muted playsinline><source src="' + videoUrl + '" type="video/mp4"></video></div><div class="modal-products-v2">' + productsHtml + '</div></div>';
          
          document.body.appendChild(popup);
          document.body.style.overflow = 'hidden';
          
          popup.querySelector('.modal-close-v2').addEventListener('click', function() {
            popup.remove();
            document.body.style.overflow = '';
          });
          
          popup.addEventListener('click', function(e) {
            if (e.target === popup) {
              popup.remove();
              document.body.style.overflow = '';
            }
          });
          
          return false;
        }, true); // trueでキャプチャフェーズ実行(最優先)
      });
      
      console.log('Video Grid initialized successfully');
    }, 500); // 500ms遅延
  };
  
  // 複数のタイミングで実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initVideoGrid);
  } else {
    window.initVideoGrid();
  }
  
  // ページ読み込み完了後にも実行
  window.addEventListener('load', window.initVideoGrid);
  
  // Shopifyセクション更新時
  document.addEventListener('shopify:section:load', window.initVideoGrid);
  
  // InstantPage対応
  document.addEventListener('instant:page-load', window.initVideoGrid);
})();
